export default "__VITE_ASSET__Dq3$Wxsl__"